app.directive('energeticChart', function() {
    return {
        scope : {
            'url' : '@'
        },
        templateUrl: "/templates/partials/directives/energeticChart.html",
        controller: ['$scope', 'crudService', '$filter', function ($scope, crudService, $filter) {
            $scope.cols = {};
            $scope.shown_cols = {};
            crudService.get($scope.url).then(generateChart);
            function generateChart(response) {
                var i, j;
                var graph_annees = []; // Stockage des années présentes dans les données
                var graph_energie = ['Electricite', 'Gaz', 'Eau'];
                var graph_energie_slug = ['electricite', 'gaz', 'eau'];
                for (i = 0 ; i < response.length ; i++) {
                    if (graph_annees.indexOf(response[i].annee) == -1) graph_annees.push(response[i].annee);
                }
                //génération des colonnes
                var cols = [];
                cols.push({
                    "label" : $filter('ucfirst')($filter('translate')('mois')),
                    "type" : "number"
                });

                for (i = 0; i < graph_annees.length; i++) {
                    for (j = 0; j < graph_energie.length; j++) {
                        cols.push({
                            "label" : graph_annees[i]+" - "+$filter('ucfirst')($filter('translate')(graph_energie_slug[j])),
                            "annee" : graph_annees[i],
                            "slug" : graph_energie_slug[j],
                            "type" : "number",
                            "color": (graph_energie_slug[j] == 'electricite') ? 'red' : 'yellow'
                        });
                        if (typeof $scope.cols[graph_energie[j]] == 'undefined') $scope.cols[graph_energie[j]] = [];
                        $scope.cols[graph_energie[j]].push(cols.length-1);
                        if (typeof $scope.shown_cols[graph_energie[j]] == 'undefined') $scope.shown_cols[graph_energie[j]] = true;
                    }
                }
                //génération des lignes
                var rows = [];
                for (var mois = 1; mois <= 12; mois++) {
                    var one_row = [];
                    one_row.push({"v" : mois});
                    for (i = 0; i < graph_annees.length; i++) {
                        for (j = 0; j < graph_energie.length; j++) {
                            var valeur = 0;
                            for (var k = 0; k < response.length; k++) {
                                if ((response[k].annee == graph_annees[i]) && (response[k].mois == mois)) valeur = response[k][graph_energie[j]];
                            }
                            if (valeur == 0) valeur = 'Vide';
                            one_row.push({"v" : valeur});
                        }
                    }
                    rows.push({"c" : one_row});
                }

                function tick(index, month_slug) {
                    return {'v' : index, f: $filter('ucfirst')($filter('translate')(month_slug))};
                }

                var colors = [];
                $scope.chart_data = {
                    type : 'LineChart',
                    options : {
                        title : $filter('ucfirst')($filter('translate')('cout total'))+' / '+$filter('ucfirst')($filter('translate')('mois')),
                        animation : {
                            duration : 1000,
                            easing : 'out',
                            startup : true
                        },
                        pointSize : 3,
                        curveType : 'function',
                        height: 400,
                        vAxis : {
                            title : $filter('ucfirst')($filter('translate')('cout')),
                            format : 'currency',
                            gridlines : {
                                color : '#e0e0e0'
                            }
                        },
                        hAxis: {
                            title : '',
                            baseline : 1,
                            ticks : [
                                tick(1, 'janvier'),
                                tick(2, 'fevrier'),
                                tick(3, 'mars'),
                                tick(4, 'avril'),
                                tick(5, 'mai'),
                                tick(6, 'juin'),
                                tick(7, 'juillet'),
                                tick(8, 'aout'),
                                tick(9, 'septembre'),
                                tick(10, 'octobre'),
                                tick(11, 'novembre'),
                                tick(12, 'decembre')
                            ],
                            gridlines : {
                                color : '#e0e0e0'
                            }
                        }
                    },
                    data : {
                        'cols' : cols,
                        'rows' : rows,
                        'allcols' : cols,
                        'allrows' : JSON.parse(JSON.stringify(rows))
                    }
                };

                function filterIndexes (value, index) {
                    return (this.indexOf(index) == -1)
                }


                var jsgradient = {
                    inputA : '',
                    inputB : '',
                    inputC : '',
                    gradientElement : '',

                    // Convert a hex color to an RGB array e.g. [r,g,b]
                    // Accepts the following formats: FFF, FFFFFF, #FFF, #FFFFFF
                    hexToRgb : function(hex){
                        var r, g, b, parts;
                        // Remove the hash if given
                        hex = hex.replace('#', '');
                        // If invalid code given return white
                        if(hex.length !== 3 && hex.length !== 6){
                            return [255,255,255];
                        }
                        // Double up charaters if only three suplied
                        if(hex.length == 3){
                            hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
                        }
                        // Convert to [r,g,b] array
                        r = parseInt(hex.substr(0, 2), 16);
                        g = parseInt(hex.substr(2, 2), 16);
                        b = parseInt(hex.substr(4, 2), 16);

                        return [r,g,b];
                    },

                    // Converts an RGB color array e.g. [255,255,255] into a hexidecimal color value e.g. 'FFFFFF'
                    rgbToHex : function(color){
                        // Set boundries of upper 255 and lower 0
                        color[0] = (color[0] > 255) ? 255 : (color[0] < 0) ? 0 : color[0];
                        color[1] = (color[1] > 255) ? 255 : (color[1] < 0) ? 0 : color[1];
                        color[2] = (color[2] > 255) ? 255 : (color[2] < 0) ? 0 : color[2];

                        return this.zeroFill(color[0].toString(16), 2) + this.zeroFill(color[1].toString(16), 2) + this.zeroFill(color[2].toString(16), 2);
                    },

                    // Pads a number with specified number of leading zeroes
                    zeroFill : function( number, width ){
                        width -= number.toString().length;
                        if ( width > 0 ){
                            return new Array( width + (/\./.test( number ) ? 2 : 1) ).join( '0' ) + number;
                        }
                        return number;
                    },

                    // Generates an array of color values in sequence from 'colorA' to 'colorB' using the specified number of steps
                    generateGradient : function(colorA, colorB, steps){
                        var result = [], rInterval, gInterval, bInterval;

                        colorA = this.hexToRgb(colorA); // [r,g,b]
                        colorB = this.hexToRgb(colorB); // [r,g,b]
                        steps -= 1; // Reduce the steps by one because we're including the first item manually

                        // Calculate the intervals for each color
                        var rStep = ( Math.max(colorA[0], colorB[0]) - Math.min(colorA[0], colorB[0]) ) / steps;
                        var gStep = ( Math.max(colorA[1], colorB[1]) - Math.min(colorA[1], colorB[1]) ) / steps;
                        var bStep = ( Math.max(colorA[2], colorB[2]) - Math.min(colorA[2], colorB[2]) ) / steps;

                        result.push( '#'+this.rgbToHex(colorA) );

                        // Set the starting value as the first color value
                        var rVal = colorA[0],
                            gVal = colorA[1],
                            bVal = colorA[2];

                        // Loop over the steps-1 because we're includeing the last value manually to ensure it's accurate
                        for (var i = 0; i < (steps-1); i++) {
                            // If the first value is lower than the last - increment up otherwise increment down
                            rVal = (colorA[0] < colorB[0]) ? rVal + Math.round(rStep) : rVal - Math.round(rStep);
                            gVal = (colorA[1] < colorB[1]) ? gVal + Math.round(gStep) : gVal - Math.round(gStep);
                            bVal = (colorA[2] < colorB[2]) ? bVal + Math.round(bStep) : bVal - Math.round(bStep);
                            result.push( '#'+this.rgbToHex([rVal, gVal, bVal]) );
                        }

                        result.push( '#'+this.rgbToHex(colorB) );

                        return result;
                    }
                };


                var reds = jsgradient.generateGradient('#FFAAAA', '#FF0000', 10);
                var blues = jsgradient.generateGradient('#AAAAFF','#0000FF', 10);
                var yellows = jsgradient.generateGradient('#FFFF00', '#DDDD00', 10);

                $scope.$watch('shown_cols', function() {
                    var ri = 0, bi = 0, yi = 0;
                    var cols_to_hide = [];
                    for (var key in $scope.shown_cols) {
                        if (!$scope.shown_cols[key]) cols_to_hide = cols_to_hide.concat($scope.cols[key])
                    }
                    $scope.chart_data.data.cols = $scope.chart_data.data.allcols.filter(filterIndexes, cols_to_hide);
                    for (var i = 0; i < $scope.chart_data.data.rows.length; i++) {
                        $scope.chart_data.data.rows[i].c = $scope.chart_data.data.allrows[i].c.filter(filterIndexes, cols_to_hide);
                    }

                    colors = [];
                    angular.forEach($scope.chart_data.data.cols, function(value) {
                        if (value.slug == 'electricite') colors.push(reds[ri++]);
                        else if(value.slug == 'gaz') colors.push(yellows[yi++]);
                        else if(value.slug == 'eau') colors.push(blues[bi++]);
                    });
                    $scope.chart_data.options.colors = colors;

                }, true);
            }
        }]
    }
});
